module.exports = __webpack_public_path__ + "img/header_banner.c29a9af8.png";